import React from 'react';
import { SingleCommonType } from '../../types';
import { refundedPlaceholder } from '../../constants/placeholder';
import CommonSingleSelect from '../../components/CommonSingleSelect';
import { refundedOptions } from '../../constants/refunded';
import { FilterButtonPoint } from '@op/operationLog/pages/filter';

export default function RefundedSelect(props: SingleCommonType) {
  return (
    <CommonSingleSelect
      {...props}
      returnKey="refunded"
      dealwithReturnValue={(value) => Number(value)}
      singlePlaceholder={refundedPlaceholder}
      options={refundedOptions}
      initValue="0"
      pointKey={FilterButtonPoint.refunded}
    />
  );
}
